module.exports = __webpack_public_path__ + "static/media/CalendarBefore.4b9b38db.svg";